import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import { useMemo, useState } from "react";
import styles from "./HistoryDetails.module.scss";
import {
    createDefaultHistoryRuleGroupUpdateView,
    defaultHistoryRuleGroupDetailsView,
} from "./ruleGroups/views/defaultHistoryRuleGroupDetailsView";
import {
    HistoryRuleGroupCreateDeleteDetailsRow,
    HistoryRuleGroupUpdateDetailsRow,
    createHistoryRuleGroupCreateDeleteViewConfig,
    createHistoryRuleGroupUpdateViewConfig,
} from "./ruleGroups/views/historyRuleGroupDetailsViewConfig";

interface HistoryRuleGroupCreateDeleteDetailsProps {
    data: HistoryRuleGroupCreateDeleteDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryRuleGroupCreateDeleteDetails: React.FC<
    HistoryRuleGroupCreateDeleteDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(defaultHistoryRuleGroupDetailsView);
    const viewConfig = useMemo(
        () => createHistoryRuleGroupCreateDeleteViewConfig(),
        [],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => (
                <EmptyState header="No rule group changes found" />
            )}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};

interface HistoryRuleGroupUpdateDetailsProps {
    data: HistoryRuleGroupUpdateDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryRuleGroupUpdateDetails: React.FC<
    HistoryRuleGroupUpdateDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(
        createDefaultHistoryRuleGroupUpdateView(),
    );
    const viewConfig = useMemo(
        () => createHistoryRuleGroupUpdateViewConfig(data),
        [data],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => (
                <EmptyState header="No rule group changes found" />
            )}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};
